type Props = {
  message: string;
};

const MessageDisplay: React.FC<Props> = ({ message }) => {
  const messageLines = message?.split("\n").map((line, index) => {
    // Check if the line starts with a bullet point or dash
    const isBulletPoint =
      line.trim().startsWith("•") ||
      line.trim().startsWith("-") ||
      line.trim().startsWith("*") ||
      line.trim().match(/^\d+\./); // numbered lists

    return (
      <span
        key={index}
        className="message-line"
        style={{
          display: "block",
          lineHeight: "1.6", // Better line height for readability
          marginBottom: isBulletPoint ? "8px" : "4px", // More space for bullet points
          marginTop: index > 0 && isBulletPoint ? "4px" : "0px", // Additional top margin for bullets
        }}
      >
        {line}
      </span>
    );
  });

  return <>{messageLines}</>;
};

export default MessageDisplay;
